import { render } from "./BarWaveLoader.vue?vue&type=template&id=e1dc1350"
import script from "./BarWaveLoader.vue?vue&type=script&lang=js"
export * from "./BarWaveLoader.vue?vue&type=script&lang=js"

import "./BarWaveLoader.vue?vue&type=style&index=0&id=e1dc1350&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__